<template>
<span>
      <div class="row">
        <div class="col-md-6">
          <div class="block block-bordered">
            <div class="block-header block-header-default">
              <h3 class="block-title">Betaaladres</h3>
            </div>
            <div class="block-content" style="overflow: hidden;">
              <div class="font-size-lg text-black mb-5">
                {{order.billing_person}}<br>
                <small v-if="order.billing_company">{{order.billing_company}}</small>
              </div>
              <address>
                {{order.billing_address}}<br>
                {{order.billing_postal_code}} {{order.billing_city}}<br><br>

                <span v-if="order.billing_phone"><i class="fa fa-phone mr-5"></i> {{order.billing_phone}}<br></span>
                <span v-if="order.billing_email" style="white-space: nowrap;"><i class="fa fa-envelope-o mr-5"></i> <a href="#">{{order.billing_email}}</a></span>
              </address>
            </div>
          </div>
        </div>

        <div class="col-md-6">
          <div class="block block-bordered">
            <div class="block-header block-header-default">
              <h3 class="block-title">Verzendadres</h3>
            </div>
            <div class="block-content" style="overflow: hidden;">
              <div class="font-size-lg text-black mb-5">
                {{order.shipping_person}}<br>
                <small v-if="order.shipping_company">{{order.shipping_company}}</small>
              </div>
              <address>
                {{order.shipping_address}}<br>
                {{order.shipping_postal_code}} {{order.shipping_city}}<br><br>

                <span v-if="order.shipping_phone"><i class="fa fa-phone mr-5"></i> {{order.shipping_phone}}<br></span>
                <span v-if="order.shipping_email" style="white-space: nowrap;"><i class="fa fa-envelope-o mr-5"></i> <a href="#">{{order.shipping_email}}</a></span>
              </address>
            </div>
          </div>
        </div>
      </div>
</span>
</template>

<script>

export default {
  props: {
    order: Object
  }
}
</script>

<style scoped>
a.disabled.block {
  cursor: not-allowed;
  opacity: 0.5;
}
</style>


// WEBPACK FOOTER //
// OrderAddress.vue?a1ded436